import * as _ from 'lodash';
import { isNullOrEmpty } from './stringUtil';

/**
 * 座標をGeoJSONオブジェクトへ変換する
 * @param {Array} coordinates - 座標
 * @returns {Object|null} GeoJSONオブジェクト
 */
export const convertCoordinatesToGeoJSON = (coordinates) => {
  if (isNullOrEmpty(coordinates)) {
    return null;
  }

  // なければ、ポリゴンの最後の座標を追加する
  const closedCoordinates = [...coordinates];
  if (
    closedCoordinates[0].lat !== closedCoordinates[closedCoordinates.length - 1].lat ||
    closedCoordinates[0].lng !== closedCoordinates[closedCoordinates.length - 1].lng
  ) {
    closedCoordinates.push(closedCoordinates[0]);
  }

  return {
    type: 'Polygon',
    coordinates: [_.map(closedCoordinates, coord => [coord.lng, coord.lat])],
  };
};

/**
 * GeoJSONかその文字列を座標変換する
 * @param {string|Object} geoJSONInput - GeoJSONオブジェクト、またはその文字列
 * @returns {Array} 座標
 */
export const parseGeoJSONToCoordinates = (geoJSONInput) => {
  if (isNullOrEmpty(geoJSONInput)) {
    return [];
  }

  let geoJSON;

  if (typeof geoJSONInput === 'string') {
    try {
      geoJSON = JSON.parse(geoJSONInput);
    } catch (error) {
      throw new Error('不正なGeoJSON: パーシングできない。');
    }
  } else if (typeof geoJSONInput === 'object') {
    geoJSON = geoJSONInput;
  } else {
    throw new Error('不正なGeoJSON: 無効な形式。');
  }

  // GeoJSON構成のバリデーション
  if (!geoJSON || geoJSON.type !== 'Polygon' || !Array.isArray(geoJSON.coordinates) || geoJSON.coordinates.length === 0) {
    throw new Error('不正なGeoJSON: フォーマットが間違っています。');
  }

  const coordinates = geoJSON.coordinates[0];
  if (!Array.isArray(coordinates) || coordinates.length === 0) {
    throw new Error('不正なGeoJSON: 座標がありません。');
  }

  return _.map(coordinates.slice(0, -1), coord => ({ lat: coord[1], lng: coord[0] }));
};



// WEBPACK FOOTER //
// ./src/utilities/geoJsonUtil.js